function extractErrorMessage(error, fallback) {
  if (error?.response?.data) {
    const data = error.response.data;
    
    // Handle standardized error format: { success: false, message: 'Unauthorised.', data: { error: 'Invalid credentials' } }
    if (data.success === false && data.data?.error) {
      return data.data.error;
    }
    
    let hasArrayError = false;
    // Check top-level keys
    for (const key in data) {
      if (Array.isArray(data[key]) && data[key].length > 0 && typeof data[key][0] === 'string') {
        hasArrayError = true;
        return data[key][0];
      }
    }
    // Check nested 'data' object for array errors
    if (data.data && typeof data.data === 'object') {
      for (const key in data.data) {
        if (Array.isArray(data.data[key]) && data.data[key].length > 0 && typeof data.data[key][0] === 'string') {
          hasArrayError = true;
          return data.data[key][0];
        }
      }
    }
    // Handle message as object with validation errors
    if (data.message && typeof data.message === 'object') {
      const validationErrors = data.message;
      const errorMessages = [];
      
      Object.keys(validationErrors).forEach(field => {
        if (Array.isArray(validationErrors[field])) {
          // Replace underscores with spaces for better readability
          const fieldLabel = field.replace(/_/g, ' ');
          validationErrors[field].forEach(msg => {
            errorMessages.push(`${fieldLabel}: ${msg}`);
          });
        }
      });
      
      if (errorMessages.length > 0) {
        return errorMessages.join('. ');
      }
    }
    if (!hasArrayError && typeof data.message === 'string') {
      return data.message;
    }
    if (!hasArrayError && typeof data.error === 'string') {
      return data.error;
    }
  }
  if (error?.message) {
    return error.message;
  }
  return fallback;
}

module.exports = { extractErrorMessage };
